import type { CommanderControlUnitChannelFilterLogicalObject } from './util/filter/filter.model';
import { restClient as restClientHttp } from '../../../axios';
import Util from '../../../util/Util';
import { mapControlUnitFilterLogicalObjectToAPIFilter } from './util/mapControlUnitFilterLogicalObjectToAPIFilter';
import {
  DigitalEventsControlUnits,
  Sensordata,
  SensordataNewest,
} from './monitoring.model';
import * as callTypes from './MonitoringCallTypes';
import { Base64 } from '../../../util/Base64';

export class MonitoringCalls {
  readonly sensorDataServiceURL = new Util().getSensorDataServiceURL();
  readonly eventServiceURL = new Util().getEventServiceURL();
  constructor(private restClient = restClientHttp) {}

  getSensordataByDeviceID(
    deviceId: string,
    start = 0,
    end = 0,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject,
    includeCloudGenerated?: boolean
  ) {
    const filter = mapControlUnitFilterLogicalObjectToAPIFilter(
      commanderFilterObject
    );

    if (filter === '{}') return Promise.resolve([]);

    const url = `${this.sensorDataServiceURL}/${Base64.encode(
      deviceId
    )}?start=${start}&end=${end}&filter=${filter}&onlyValid=true${
      includeCloudGenerated ? '&includeCloudGenerated=true' : ''
    }`;
    return this.restClient.callPromise<Sensordata[]>(
      {
        url,
        method: 'GET',
      },
      callTypes.getSensordataByDeviceID
    );
  }

  getEventsByID(
    deviceId: string,
    start = 0,
    end = 0,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject
  ) {
    const filter = mapControlUnitFilterLogicalObjectToAPIFilter(
      commanderFilterObject
    );
    if (filter === '{}') return Promise.resolve([]);

    const url = `${this.eventServiceURL}/${Base64.encode(
      deviceId
    )}?start=${start}&end=${end}&filter=${filter}&onlyValid=true`;
    return this.restClient.callPromise<DigitalEventsControlUnits[]>(
      {
        url,
        method: 'GET',
      },
      callTypes.getSensordataByDeviceID
    );
  }

  getConnectionInfoByID(
    deviceId: string,
    start = 0,
    end = 0,
    channels: string[] = []
  ) {
    const url = `${this.eventServiceURL}/${Base64.encode(
      deviceId
    )}/device?start=${start}&end=${end}&channels=${JSON.stringify(channels)}`;
    return this.restClient.callPromise<DigitalEventsControlUnits[]>(
      {
        url,
        method: 'GET',
      },
      callTypes.getSensordataByDeviceID
    );
  }

  getCurrentEventsByID(deviceId: string) {
    const url = `${this.eventServiceURL}/${Base64.encode(deviceId)}/newest`;
    return this.restClient.get<DigitalEventsControlUnits[]>(url);
  }

  getCurrentSensorDataByID(deviceId: string) {
    const url = `${this.sensorDataServiceURL}/${Base64.encode(
      deviceId
    )}/newest`;
    return this.restClient.get<SensordataNewest[]>(url);
  }
}
